import { BrowserCacheLocation } from '@azure/msal-browser';

export const environment = {
    production: true,
    stage: 'dev',
    apiUrl: 'https://api.dev.gbr.erholung.siemens-healthineers.com/v1',
    translationsUrl: 'https://files.translations.dev.gbr.erholung.siemens-healthineers.com',
    cdnBaseUrl: 'https://files.dev.gbr.erholung.siemens-healthineers.com',
    featureFlags: {
        delegatesEnabled: false
    },
    msalConfig: {
        auth: {
            clientId: '412aa3d6-c451-4305-9de8-6f8f88984122', // Your application's client ID from Entra ID
            authority: 'https://login.microsoftonline.com/5dbf1add-202a-4b8d-815b-bf0fb024e033', // Your tenant ID in format https://login.microsoftonline.com/${tenantId}
            redirectUri: window.location.origin, // Where to redirect after login, this needs to match exactly the redirectUri in Azure
            postLogoutRedirectUri: window.location.origin, // Where to redirect after logout
            navigateToLoginRequestUrl: true // Navigate back to the original request URL after login, this needs to match exactly the redirectUri in Azure
        },
        cache: {
            cacheLocation: BrowserCacheLocation.SessionStorage, // Store auth data in session storage
            storeAuthStateInCookie: false // Don't use cookies for state
        },
        system: {
            allowPlatformBroker: false // Don't use platform brokers like WAM
        }
    },
    apiConfig: [
        {
            scopes: ['openid', 'profile', 'email', 'offline_access', 'User.Read'], // Microsoft Graph API permissions to request
            uri: 'https://graph.microsoft.com/v1.0'
        },
        {
            scopes: ['api://ae2ed25e-13dd-46b9-9bd4-eae63a93a3d9/api.ReadWrite'], // API permissions to request, here you can add more delegated permissions
            uri: 'https://api.dev.gbr.erholung.siemens-healthineers.com' // Your backend API URI
        }
    ]
};
